import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { DeviceService } from 'src/app/services/device.service';
import { DivisionService } from 'src/app/services/division.service';
import { AlertService } from 'src/app/services/alert.service';
import { InputformatService } from 'src/app/services/inputformat.service';
@Component({
  selector: 'app-machinary-clasificationassign',
  templateUrl: './machinary-clasificationassign.component.html',
  styleUrls: ['./machinary-clasificationassign.component.scss']
})



export class MachinaryClasificationassignComponent implements OnInit {
  @Input() actionId: any;
  @Input() resultdata: any;
  @Output() backComp = new EventEmitter<any>();
  valuesForm!: FormGroup;
  value: any;
  compVal: any[] = [];
  selectedValue: any[];
  id: any;
  GetByIdResponse: any;
  filtercompVal: any[];

  constructor
    (
      private fb: FormBuilder,
      private location: Location,
      private dptmasterservice: DptmasterService,
      private divisionService: DivisionService,
      private alertService: AlertService,
      private inputFormatService : InputformatService

    ) { }

  ngOnInit(): void {
    this.id = this.resultdata.id ? this.resultdata.id : 0
    this.initializeForm();
    this.getLookup();

    if (this.id) {
      this.getSchemeLookyp(this.id);
    }

  }



  initializeForm() {
    this.valuesForm = this.fb.group({
      name: new FormControl('', Validators.required),
      // MachinaryClassificationType: new FormControl('', Validators.required),
    });
  }
  getSchemeLookyp(id: number) {
    this.dptmasterservice.getMachinaryClassificationbyId(true, id).subscribe((res) => {
      this.GetByIdResponse = res

      if (this.GetByIdResponse) {
        this.valuesForm.patchValue({
          name: res.name,
          // MachinaryClassificationType: res.machinaryClassificationType,
        });
      }
      // console.log('this.valuesForm.value.MachinaryClassificationType', this.valuesForm.value.MachinaryClassificationType);

    })
  }
  getLookup() {
    this.dptmasterservice.MachinaryclassificationLookup().subscribe((res) => {
      this.compVal = res
      this.filtercompVal = this.compVal.slice();
    })
  }
  getDbtProduct() {
    this.dptmasterservice.getdbtGoScheme(true).subscribe((res) => {
      this.value = res
      this.valuesForm.controls['name'].setValue(this.value.name)
      // this.valuesForm.controls['MachinaryClassificationType'].setValue(this.value.MachinaryClassificationType)
    })
  }

  back() {
    const msg = { show: true };
    this.backComp.emit(msg);
  }

  Update() {
    if (this.valuesForm.valid) {

      let data = {
        "id": this.id,
        "name": this.valuesForm.value.name,
        // "machinaryClassificationType": this.valuesForm.value.MachinaryClassificationType
      }
      this.dptmasterservice.UpdateMachinaryClassificationby(data).subscribe((res) => {
        if (res.isSuccess) {
          this.alertService.success(this.actionId==0 ? 'Machinary Classification Saved Successfully':this.actionId==1 ?  'Machinary Classification Updated Successfully':'' );
          this.back()
        }
      })
    }
    else{
      this.valuesForm.markAllAsTouched();
    }
  }

  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

}